import React from 'react'
import { Route, Routes } from 'react-router'
import Home from '../Home/Home'
import Navbar from '../Navbar/Navbar'
import Test from '../Test/Test'

const AllRoutes = () => {
  return (
    <div>
     <Navbar />
     <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/test' element={<Test />} />
     </Routes>
    </div>
  )
}

export default AllRoutes
